import React from 'react';
import { useDrop } from 'react-dnd';
import { FormContainerList, FormItemTypes } from '../../../utils/formBuilderUtils';
import { Button } from '@mui/material';
import ControlViewComponent from './ControlViewComponent';
import './styles.scss';

const DropContainerComponent = ({
  accept,
  layout,
  childrenComponents,
  index,
  deleteContainer,
  deleteControl,
  selectControl,
  selectedControl,
  handleItemAdded,
  moveControl,
}) => {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: accept,
    drop: () => layout,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  const isActive = canDrop && isOver;
  let backgroundColor = accept && accept === FormItemTypes.CONTROL ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.1)';
  let borderColor = 'rgba(0,0,0,0.1)';
  const borderBase = '1px solid';
  let border;

  if (isActive) {
    backgroundColor = 'rgba(46,212,182,0.4)';
  } else if (canDrop) {
    backgroundColor = 'rgba(255,178,15,0.7)';
  }

  if (accept === FormItemTypes.CONTROL) {
    border = `${borderBase} ${borderColor}`;
  }

  if (selectedControl && selectedControl.itemType === layout?.itemType && selectedControl.id === layout.id) {
    borderColor = 'rgb(255, 193, 7)';
    border = `${borderBase} ${borderColor}`;
  }

  const handleDeleteContainer = (event) => {
    if (deleteContainer) {
      deleteContainer(layout?.id);
    }
    event.stopPropagation();
  };

  return (
    <div
      className="col-12 container-drop"
      ref={drop}
      style={{ backgroundColor, borderRadius: "9px", border }}
    >
      {accept === FormItemTypes.CONTAINER && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "90px" }}
        >
          <Button
            onClick={() => {
              if (handleItemAdded) {
                handleItemAdded({ ...FormContainerList[0] });
              }
            }}
          >
            <span style={{ marginRight: "9px" }}>
              <i className="fa fa-plus"></i>
            </span>
            <span>Add a workflow step</span>
          </Button>
        </div>
      )}

      {accept === FormItemTypes.CONTROL && (
        <div
          onClick={() => {
            if (selectControl) {
              selectControl(layout);
            }
          }}
          className="container-header d-flex justify-content-between py-3 mb-3"
          style={{
            borderBottom: "1px solid rgba(0,0,0,0.1)",
            cursor: "pointer",
          }}
        >
          <h5>Step {(index) + 1}</h5>
          <div className="container-actions" style={{ fontSize: "1.1rem" }}>
            <span style={{ cursor: "grab" }}>
              <i className="fa fa-ellipsis-v"></i>
              <i className="fa fa-ellipsis-v"></i>
            </span>
            <span onClick={handleDeleteContainer}>
              <i className="fa fa-trash"></i>
            </span>
          </div>
        </div>
      )}

      <h4>{layout?.heading}</h4>
      <p>{layout?.subHeading}</p>
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "20vh", position: "relative" }}>
        {childrenComponents?.length === 0 ? (
          <div>
            <span style={{ marginRight: "9px" }}>
              <i className="fa fa-plus"></i>
            </span>
            <span>Drop Field</span>
          </div>
        ) : (
          <>
            {childrenComponents?.map((component, ind) => (
              <ControlViewComponent
                key={component.id}
                item={component}
                deleteControl={deleteControl}
                selectControl={selectControl}
                selectedControl={selectedControl}
                containerId={layout?.id}
                index={ind}
                moveControl={moveControl}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default DropContainerComponent;
